import { put, takeEvery } from 'redux-saga/effects';

import { SEND_MESSAGE } from './druid/actions/sendMessage';
import postActivity from './druid/actions/postActivity';
import whileConnected from '/druid/effects/whileConnected';

function* postActivityWithMessage({ payload: { channelData, method, text } }) {
  yield put(
    postActivity(
      {
        channelData,
        text,
        textFormat: 'plain',
        type: 'message'
      },
      method
    )
  );
}

function* sendMessageToPostActivity() {
  yield takeEvery(({ payload, type }) => type === SEND_MESSAGE && payload.text, postActivityWithMessage);
}

export default function* sendMessageToPostActivitySaga() {
  yield whileConnected(sendMessageToPostActivity);
}
